import { Alert, Slide, Snackbar } from "@mui/material";
import { useSnackbars } from "../../store/snackbars/hooks";
import {
  RESPONSE_MESSAGE,
  RESPONSE_STATUS,
} from "../../pages/app/utils/constants";

export const AlignClipsSnackbarWS = () => {
  const {
    showAlignClipsSnackbarWS,
    alignClipsResponseWS,
    closeAlignClipsSnackbarWS,
    clearAlignClipsResponseWS,
  } = useSnackbars();

  const { message, status } = alignClipsResponseWS;

  const displayedMessage =
    RESPONSE_STATUS[status] === "success"
      ? "Clips aligned successfully!"
      : `Error aligning clips: ${RESPONSE_MESSAGE[message] || "Unknown error."}`;

  const handleClose = () => closeAlignClipsSnackbarWS();
  const handleExited = () => clearAlignClipsResponseWS();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={showAlignClipsSnackbarWS}
      autoHideDuration={5000}
      onClose={handleClose}
      slots={{
        transition: Slide,
      }}
      slotProps={{
        transition: {
          direction: "up",
          onExited: handleExited,
        },
      }}
      sx={{
        "&.MuiSnackbar-root": { bottom: 84, width: 370 },
      }}
    >
      <Alert
        onClose={handleClose}
        severity={RESPONSE_STATUS[status]}
        variant="filled"
        sx={{
          boxShadow: 3,
          width: "100%",
        }}
      >
        {displayedMessage}
      </Alert>
    </Snackbar>
  );
};
